import {action, observable} from 'mobx';
import {callCallEdit} from '../../helpers/api/call';

export class Call {
  @observable data = {};
  @observable isUpdatingComment = false;
  @observable isEditingComment = false;

  @observable isUpdatingImportant = false;

  constructor(store, data) {
    this.store = store;
    this.data = data;
  }


  @action startEditComment() {
    this.isEditingComment = true;
  }

  @action stopEditComment() {
    this.isEditingComment = false;
  }

  @action async updateComment(newComment) {
    this.isUpdatingComment = true;
    await callCallEdit({ id: this.id, comment: newComment });
    this.data.comment = newComment;
    this.isUpdatingComment = false;
    this.isEditingComment = false;
  }

  @action async updateImportant(newImportant) {
    this.isUpdatingImportant = true;
    await callCallEdit({ id: this.id, important: newImportant });
    this.data.important = newImportant;
    this.isUpdatingImportant = false;
  }

  get id() {
    return this.data._id;
  }
}



// WEBPACK FOOTER //
// ./src/stores/call/call.js